"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @param {*location.search} str
 * @description  获取地址栏上的参数，最后以对象的形式返回
 *
 */
exports.default = (function (query) {
    if (query === void 0) { query = window.location.search.substr(1); }
    var reg = /([^=&\s]+)[=\s]*([^&\s]*)/g;
    var obj = {};
    while (reg.exec(query))
        obj[RegExp.$1] = RegExp.$2;
    return obj;
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnF1ZXJ5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL2ZxdWVyeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBOzs7OztHQUtHO0FBQ0gsbUJBQWUsVUFBQyxLQUF3QztJQUF4QyxzQkFBQSxFQUFBLFFBQVEsTUFBTSxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztJQUN0RCxJQUFNLEdBQUcsR0FBRyw0QkFBNEIsQ0FBQTtJQUN4QyxJQUFNLEdBQUcsR0FBOEIsRUFBRSxDQUFBO0lBQ3pDLE9BQU8sR0FBRyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7UUFBRSxHQUFHLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxHQUFHLE1BQU0sQ0FBQyxFQUFFLENBQUE7SUFDbEQsT0FBTyxHQUFHLENBQUE7QUFDWixDQUFDLEVBQUEifQ==